import React from "react";

import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";

import { Blur, Truncate } from "./BlurredText.styles";

interface Props {
  text: string;
  isLimited?: boolean;
  limit?: number;
  paddingLeft?: number;
}

export const BlurredText = ({ text, isLimited, limit = 5, paddingLeft }: Props) => {
  const { selectedWorkspace, selectedApp } = useAppSelectionContext();
  if (
    !isLimited ||
    text.length <= limit ||
    selectedWorkspace?.is_free ||
    selectedWorkspace?.has_subscription ||
    selectedApp?.is_extension ||
    selectedApp?.is_sample
  ) {
    return <Truncate $paddingLeft={paddingLeft}>{text}</Truncate>;
  }

  return (
    <Truncate $paddingLeft={paddingLeft}>
      <span>{text.slice(0, limit)}</span>
      <Blur>{text.slice(limit)}</Blur>
    </Truncate>
  );
};
